/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningOutcomeTemplateDTO,
    LearningOutcomeTemplateDTOFromJSON,
    LearningOutcomeTemplateDTOFromJSONTyped,
    LearningOutcomeTemplateDTOToJSON,
} from './LearningOutcomeTemplateDTO';
import {
    SimpleStudyCycleEnum,
    SimpleStudyCycleEnumFromJSON,
    SimpleStudyCycleEnumFromJSONTyped,
    SimpleStudyCycleEnumToJSON,
} from './SimpleStudyCycleEnum';

/**
 * 
 * @export
 * @interface DomainUpdateDTO
 */
export interface DomainUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof DomainUpdateDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DomainUpdateDTO
     */
    scienceBranchId?: string;
    /**
     * 
     * @type {SimpleStudyCycleEnum}
     * @memberof DomainUpdateDTO
     */
    studyCycle?: SimpleStudyCycleEnum;
    /**
     * 
     * @type {string}
     * @memberof DomainUpdateDTO
     */
    abbreviation?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DomainUpdateDTO
     */
    facultyIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DomainUpdateDTO
     */
    studyProgramIds?: Array<string> | null;
    /**
     * 
     * @type {Array<LearningOutcomeTemplateDTO>}
     * @memberof DomainUpdateDTO
     */
    learningOutcomeTemplates?: Array<LearningOutcomeTemplateDTO> | null;
}

export function DomainUpdateDTOFromJSON(json: any): DomainUpdateDTO {
    return DomainUpdateDTOFromJSONTyped(json, false);
}

export function DomainUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'scienceBranchId': !exists(json, 'scienceBranchId') ? undefined : json['scienceBranchId'],
        'studyCycle': !exists(json, 'studyCycle') ? undefined : SimpleStudyCycleEnumFromJSON(json['studyCycle']),
        'abbreviation': !exists(json, 'abbreviation') ? undefined : json['abbreviation'],
        'facultyIds': !exists(json, 'facultyIds') ? undefined : json['facultyIds'],
        'studyProgramIds': !exists(json, 'studyProgramIds') ? undefined : json['studyProgramIds'],
        'learningOutcomeTemplates': !exists(json, 'learningOutcomeTemplates') ? undefined : (json['learningOutcomeTemplates'] === null ? null : (json['learningOutcomeTemplates'] as Array<any>).map(LearningOutcomeTemplateDTOFromJSON)),
    };
}

export function DomainUpdateDTOToJSON(value?: DomainUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'scienceBranchId': value.scienceBranchId,
        'studyCycle': SimpleStudyCycleEnumToJSON(value.studyCycle),
        'abbreviation': value.abbreviation,
        'facultyIds': value.facultyIds,
        'studyProgramIds': value.studyProgramIds,
        'learningOutcomeTemplates': value.learningOutcomeTemplates === undefined ? undefined : (value.learningOutcomeTemplates === null ? null : (value.learningOutcomeTemplates as Array<any>).map(LearningOutcomeTemplateDTOToJSON)),
    };
}

